'use strict';

import Dimensions from '../Dimensions';
import { useEffect, useState } from 'react';
export default function useWindowDimensions() {
  var _useState = useState(function () {
    return Dimensions.get('window');
  }),
      dims = _useState[0],
      setDims = _useState[1];

  useEffect(function () {
    function handleChange(_ref) {
      var window = _ref.window;
      setDims(window);
    }

    Dimensions.addEventListener('change', handleChange);
    setDims(Dimensions.get('window'));
    return function () {
      Dimensions.removeEventListener('change', handleChange);
    };
  }, []);
  return dims;
}